import React from "react";

import { Box } from "@mui/material/";
const style = {
  margin: 0,
  padding: 0,
};

const FilePreview = ({ data, fileName }) => {
  console.log("data", data);
  return (
    <Box sx={style}>
      <object
        data={data}
        style={{
          minHeight: "calc(100vh - 100px)",
          width: "100%",
          objectFit: "contain",
        }}
      />
    </Box>
  );
};

export default FilePreview;
